'format es6';
'use strict';

import $ from 'jquery';
import gsap from 'greensock';
import ns from 'ns';
import User from '../User';
import { factory as sectionFactory } from './Section';

require('magnific-popup');
require('../../views-compiled/home');

const EASING = gsap.Expo;

function Home() {
	this.templateName = 'home.htm';

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 0.3, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 0.3, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	/**
	 * Waits for the User.onReady Promise and then checks if the language
	 * set is the same as the one saved in the previous results of the User.
	 * 
	 * If they are the same, the Promise resolves with an object wrapping 
	 * and extending the User._data object.
	 * 
	 * If they are different, the Promise resolves with User.getDifferentLangFamilies() which
	 * in turn resolves with the object wrapping and extending the User._data object.
	 * 
	 * @Promise {Object} - Wrapped and extended version of the User._data object
	 * @Reject {Void} message - Console logs an error message
	 * 
	 * @return {Promise}
	 */
	this.init = () => {
		return User.onReady().then((user) => {
			if (!User.get('lang')) {
				User.set('lang', { lang: ns.lang });
			}

			if (User.get('lang').lang !== ns.lang) {
				return User.getDifferentLangFamilies().then((_user) => {
					return {
						user: Object.assign({
							isLogged: _user.isLogged(),
							isReturning: _user.isReturning(),
						}, _user._data),
					};
				});
			} else {
				return {
					user: Object.assign({
						isLogged: user.isLogged(),
						isReturning: user.isReturning(),
					}, user._data),
				};
			}

		}).catch((e) => {
			console.log('User Promise rejected');
		});
	}

	this.activate = () => {
		const cta = $('[data-cta-start]', this.sectionNode);
		const accountLinks = $('[data-account-links]', this.sectionNode);
		const newTestCta = $('[data-new]', this.sectionNode);
		const resumeTestCta = $('[data-resume]', this.sectionNode);

		newTestCta.on('click.cursus', (e) => {
			e.preventDefault();

			User.destroy();

			if (!User.get('lang')) {
				User.set('lang', { lang: ns.lang });
			}

			ns.Menu.updateData();
			this.animateOut().then(() => {
				this.next && this.next();
			});
		});

		resumeTestCta.on('click.cursus', (e) => {
			e.preventDefault();

			this.animateOut().then(() => {
				this.next && this.next(true);
			});
		});

		accountLinks.each((i, el) => {
			$(el).magnificPopup({
				type: 'iframe',
				mainClass: 'iframe-popup',
				callbacks: {
					afterClose: () => {
						window.location.reload();
					},
				},
				disableOn() {
					if (ns.isMobile()) {
						return false;
					}

					return true;
				},
			});
		});

		cta.on('click.cursus', (e) => {
			e.preventDefault();
			this.animateOut().then(() => {
				this.next && this.next();
			});
		});

		ns.Menu.updateData();
	};

	return this;
}


export function factory(instance) {
	return Home.call(sectionFactory(instance || {}));
}
